import {Grid} from "@mui/system";

import {DefaultCardStructure} from "components";
import pxToRem from "hooks/usePxToRem";
import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {calcConsideredWeight} from "../../utils/calculateConsideredWeight";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";

interface Props {
  loadIndex: number;
}

const HouseMeasurements = (props: Props) => {
  const {watch, control, setValue, getValues} = useFormContext();
  const [temporaryValue, setTemporaryValue] = useState<{
    consideredWeight: number;
    cubeWeight: number;
    chargeableWeight?: number;
  } | null>(null);

  const isAiProcess =
    `${getValues("operation")?.[0]}${getValues("modality")?.[0]}` === "IA";

  const handleCalcWeights = () => {
    const loadData = calcConsideredWeight(
      watch(`processLoads[${props.loadIndex}].cubicMeters`) ?? 0,
      watch(`processLoads[${props.loadIndex}].grossWeight`) ?? 0,
      isAiProcess,
    );

    setTemporaryValue(loadData);
    setValue(
      `processLoads[${props.loadIndex}].consideredWeight`,
      loadData.consideredWeight,
      {shouldDirty: true},
    );
    setValue(
      `processLoads[${props.loadIndex}].cubeWeight`,
      loadData.cubeWeight,
      {shouldDirty: true},
    );
  };

  return (
    <DefaultCardStructure title="Medidas House" hasDivider={false} isSubcard>
      <Grid container spacing={pxToRem(8)} mb={pxToRem(20)}>
        <Grid size={isAiProcess ? 2 : 3}>
          <Controller
            name={`processLoads[${props.loadIndex}].grossWeight`}
            control={control}
            render={({field: {value}}) => (
              <ProcessTextField
                value={value ?? 0}
                name={`processLoads[${props.loadIndex}].grossWeight`}
                placeholder="Peso bruto"
                onChange={(e) => {
                  setValue(
                    `processLoads[${props.loadIndex}].grossWeight`,
                    +e.target.value,
                    {shouldDirty: true},
                  );
                  handleCalcWeights();
                }}
                size="small"
                type="number"
                fullWidth
                label="Peso Bruto - kg"
                inputProps={{
                  min: 0.0,
                  step: 0.001,
                }}
              />
            )}
          />
        </Grid>

        <Grid size={isAiProcess ? 2 : 3}>
          <Controller
            name={`processLoads[${props.loadIndex}].cubicMeters`}
            control={control}
            render={({field: {value}}) => (
              <ProcessTextField
                value={value ?? 0}
                name={`processLoads[${props.loadIndex}].cubicMeters`}
                placeholder="m³"
                onChange={(e) => {
                  setValue(
                    `processLoads[${props.loadIndex}].cubicMeters`,
                    +e.target.value,
                    {shouldDirty: true},
                  );
                  handleCalcWeights();
                }}
                size="small"
                type="number"
                fullWidth
                label="Metros Cúbicos"
                inputProps={{
                  min: 0.0,
                  step: 0.001,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={isAiProcess ? 1.5 : 2}>
          <Controller
            name={`processLoads[${props.loadIndex}].quantities`}
            control={control}
            render={({field: {value}}) => (
              <ProcessTextField
                value={value ?? 0}
                name={`processLoads[${props.loadIndex}].quantities`}
                placeholder="m³"
                onChange={(e) => {
                  setValue(
                    `processLoads[${props.loadIndex}].quantities`,
                    +e.target.value,
                    {shouldDirty: true},
                  );
                }}
                size="small"
                type="number"
                fullWidth
                label="Quantidade"
                inputProps={{
                  min: 0.0,
                  step: 0.001,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={2}>
          <Controller
            name={`processLoads[${props.loadIndex}].cubeWeight`}
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                disabled
                value={temporaryValue?.cubeWeight ?? value}
                name={`processLoads[${props.loadIndex}].cubeWeight`}
                placeholder="Peso cubado"
                onChange={onChange}
                size="small"
                type="number"
                fullWidth
                label="Peso Cubado - kg"
                inputProps={{
                  min: 0,
                  step: 0.001,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={"grow"}>
          <Controller
            name={`processLoads[${props.loadIndex}].consideredWeight`}
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                value={temporaryValue?.consideredWeight ?? value}
                disabled
                name={`processLoads[${props.loadIndex}].consideredWeight`}
                placeholder="Peso considerado"
                onChange={onChange}
                size="small"
                type="number"
                fullWidth
                label="Peso Considerado - kg"
                inputProps={{
                  min: 0,
                  step: 0.001,
                }}
              />
            )}
          />
        </Grid>
        {isAiProcess && (
          <Grid size={2}>
            <Controller
              name={`processLoads[${props.loadIndex}].chargeableWeight`}
              control={control}
              render={({field: {onChange, value}}) => (
                <ProcessTextField
                  value={temporaryValue?.chargeableWeight ?? value}
                  disabled
                  name={`processLoads[${props.loadIndex}].chargeableWeight`}
                  placeholder="Peso taxado"
                  onChange={onChange}
                  size="small"
                  type="number"
                  fullWidth
                  label="Peso taxado"
                  inputProps={{
                    min: 0,
                    step: 0.001,
                  }}
                />
              )}
            />
          </Grid>
        )}
      </Grid>
    </DefaultCardStructure>
  );
};

export default HouseMeasurements;
